//imports
import {
    KEYSFOBS_DELETE_REQUEST,
    KEYSFOBS_DELETE_RESULT,
    KEYSFOBS_DELETE_OPEN_MODAL,
    CLEAR_REDUX,
} from 'Redux/actionTypes';

//initial values
const INIT_STATE = {
    openModal: false,
    loading: false,
    result: null,
    keyfob: null
};

//change redux object
export default (state = INIT_STATE, action) => {
    switch (action.type) {

        case KEYSFOBS_DELETE_REQUEST:
            return { ...state, loading: true }

        case KEYSFOBS_DELETE_RESULT:
            return { ...state, loading: false, result: action.payload }

        case KEYSFOBS_DELETE_OPEN_MODAL:
            return { ...state, openModal: true, keyfob: action.payload }

        case CLEAR_REDUX:
            return ["", "KEYFOBS_DELETE"].includes(action.payload.option)
                ? action.payload.parameters
                    ? { ...state, ...action.payload.parameters }
                    : { ...INIT_STATE }
                : { ...state };

        default:
            return state;
    }
};